/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import { Select, Tooltip } from 'antd'
import { Input } from '@/ui'
import TextAreaModelSearchCommen from '@/components/QueryWidgets/TextAreaModelSearchCommen'
import { getRootDom } from '@/utils/utils'
import useRecordOperation from '@/hooks/useRecordOperation'
import TextAreaModel from '../TextAreaModelSearchCommen/components/TextAreaModel'
import styles from './index.less'
import noop from 'lodash/noop'
import classNames from 'classnames'

export const TALENT_PRECISE_TYPE = '1'
export const TALENT_DIM_TYPE = '0'

export const TALENT_TYPE = [
    {
        value: TALENT_PRECISE_TYPE,
        label: '精确匹配'
    },
    {
        value: TALENT_DIM_TYPE,
        label: '模糊匹配'
    }
]

const CODE_TIP = ['资料编码', '商品编码', '款式编码']

// TODO 新版查询 leftWidth rightWidth 这两个属性可以弃用掉了
export default ({
    value,
    onChange,
    disabled,
    leftWidth = '35%',
    rightWidth = '65%',
    rightDisabled,
    matchTips,
    tip = '',
    fuzzyTips,
    wrap = false,
    allowClear = false,
    initSelected,
    triggerModelOnEnter,
    storagekey,
    uid,
    modalType = null,
    placeholder = '',
    getPopupContainer,
    // 精确搜索只支持单个
    preciseTypeOnlySingle,
    ...restProps
}) => {
    const [selected, setSelected] = useState(false)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (initSelected && value && value.leftValue && value.rightValue) {
            setSelected(value.leftValue)
        }
    }, [initSelected, value])

    // 是否缓存为精确匹配
    const { isRecord, saveRecordStatus } = useRecordOperation({ name: storagekey, latitudeType: uid })
    const defaultValue = isRecord ? TALENT_PRECISE_TYPE : TALENT_DIM_TYPE

    const onChangeText = ({ text, type }) => {
        setSelected(type)
        onChange({
            ...value,
            leftValue: type,
            rightValue: text
        })
    }
    const onEnterPress = e => {
        if (e.key === 'Enter' || e.code === 'Enter') {
            setVisible(true)
        }
    }

    const tips = [
        {
            label: `多个${tip}，以逗号分隔或每行一个${tip}`,
            visible: true
        },
        {
            label: `若${tip}中带有逗号，请使用模糊搜索`,
            visible: CODE_TIP.includes(tip)
        }
    ]
        .filter(v => v.visible)
        .map(v => v.label)
        .join(`\n`)

    return (
        <div {...restProps} className={styles.selecteComponentBox}>
            <Input.Group
                compact
                className={classNames(styles.flex, {
                    [styles.hasWrap]: wrap
                })}
            >
                <Select
                    allowClear={allowClear}
                    style={{ width: leftWidth, minWidth: 100 }}
                    value={value?.leftValue || defaultValue}
                    disabled={disabled}
                    className={classNames(
                        selected ? styles.activeContainer : styles.container,
                        'compact-query-left-placeholder'
                    )}
                    onChange={val => {
                        setSelected(val)
                        saveRecordStatus && saveRecordStatus(val === TALENT_PRECISE_TYPE)
                        onChange({
                            ...value,
                            leftValue: val
                        })
                    }}
                    options={TALENT_TYPE}
                    getPopupContainer={typeof getPopupContainer === 'function' ? getPopupContainer : getRootDom}
                />
                <div className={styles.right} style={{ width: `calc(${rightWidth} + 1px)` }}>
                    {(selected || value?.leftValue || defaultValue) !== TALENT_DIM_TYPE ? (
                        preciseTypeOnlySingle ? (
                            <Tooltip title={fuzzyTips} trigger="focus">
                                {/* fuzzyInput类名不能删 */}
                                <Input
                                    {...(triggerModelOnEnter
                                        ? {
                                              'data-keyenterevent': true
                                          }
                                        : {})} // 不触发父级enter事件
                                    placeholder={placeholder ? placeholder : `请输入${tip}`}
                                    value={value?.rightValue}
                                    disabled={rightDisabled}
                                    onChange={e => {
                                        onChangeText({ text: e.target.value, type: TALENT_PRECISE_TYPE })
                                    }}
                                    className="fuzzyInput"
                                    allowClear
                                    onKeyUp={triggerModelOnEnter ? onEnterPress : noop}
                                />
                            </Tooltip>
                        ) : (
                            <TextAreaModelSearchCommen
                                dataSource={{
                                    placeholder: placeholder ? placeholder : `多个${tip}，以逗号分隔`,
                                    modelTitle: tip,
                                    tips
                                }}
                                onChange={text => {
                                    onChangeText({ text, type: TALENT_PRECISE_TYPE })
                                }}
                                disabled={rightDisabled}
                                value={value?.rightValue}
                                tipTitle={matchTips}
                                triggerModelOnEnter={triggerModelOnEnter}
                                trigger="focus"
                                modalType={modalType}
                            />
                        )
                    ) : (
                        <Tooltip title={fuzzyTips} trigger="focus">
                            {/* fuzzyInput类名不能删 */}
                            <Input
                                {...(triggerModelOnEnter
                                    ? {
                                          'data-keyenterevent': true
                                      }
                                    : {})} // 不触发父级enter事件
                                placeholder={placeholder ? placeholder : `请输入${tip}`}
                                value={value?.rightValue}
                                disabled={rightDisabled}
                                onChange={e => {
                                    onChangeText({ text: e.target.value, type: TALENT_DIM_TYPE })
                                }}
                                className="fuzzyInput"
                                allowClear
                                onKeyUp={triggerModelOnEnter ? onEnterPress : noop}
                            />
                        </Tooltip>
                    )}
                </div>
            </Input.Group>
            {visible && (
                <TextAreaModel
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    defaultValue={value?.rightValue}
                    onOk={text => {
                        setVisible(false)
                        onChangeText({ text, type: TALENT_PRECISE_TYPE })
                    }}
                    data={{
                        placeholder: placeholder ? placeholder : `多个${tip}，以逗号分隔`,
                        modelTitle: tip,
                        tips: `多个${tip}，以逗号分隔或每行一个${tip}`
                    }}
                />
            )}
        </div>
    )
}
